const VipToastSwiper = {
  maiba: [
    'https://qncweb-back1.ktvsky.com/20210616/vadd/aa8e91e239004f93c93c3fd4fc348140.png',
    'https://qncweb-back1.ktvsky.com/20210616/vadd/d0d2698af906ead434bc904680d20846.png',
    'https://qncweb-back1.ktvsky.com/20210616/vadd/4a9dbdbdce61c70e91f044cd79e04b83.png',
    'https://qncweb-back1.ktvsky.com/20210616/vadd/fd988dcb7b46ff1afe1c32bedb5b508a.png',
    'https://qncweb-back1.ktvsky.com/20210616/vadd/33794feb4ce1da37df0bc1ee7e2d2642.png',
  ],
  djhot: [
    'https://qncweb-back1.ktvsky.com/20210608/vadd/4232b1f6d84d51c316e132ea5929afe1.png',
    'https://qncweb-back1.ktvsky.com/20210712/vadd/359a3028e9f98046ce3b28fbe64641b1.png',
    'https://qncweb-back1.ktvsky.com/20210608/vadd/68783280fd335629a3c97f94ec750122.png',
    'https://qncweb-back1.ktvsky.com/20210608/vadd/297e55b5ae6633b269f328010d17c410.png',
    'https://qncweb-back1.ktvsky.com/20210608/vadd/c944718ceb5274e73def0de0cf286dcf.png',
  ],
  gold: [
    'https://qncweb-back1.ktvsky.com/20220805/vadd/8e036b7faee860552f10daedb23193f2.png',
    'https://qncweb-back1.ktvsky.com/20210609/vadd/7b30ebfdf3bba7b2e1db3cc20b109b69.png',
    'https://qncweb-back1.ktvsky.com/20210609/vadd/765f8e018311d8138bd8e327b9c20db0.png',
    'https://qncweb-back1.ktvsky.com/20210609/vadd/f0c732a3c281b5dc0a528e3f347c1b16.png',
  ],
};
export { VipToastSwiper };
